export enum CONSTANTS {
  DEFAULT_REPLAY_SECTION = 'default_replay_section',
}
